import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getSalesLocations, createSalesLocation, updateSalesLocation, deleteSalesLocation, getSalesLocation } from "../api";
import { useNavigate } from "react-router-dom";
import { useNotification } from "../../../contexts/NotificationContext";

export const useGetSalesLocations = (page, pageSize, search) => {
  const { data, isLoading, status, isError, error, isSuccess } = useQuery({
    queryKey: ["sales-locations", page, pageSize, search],
    queryFn: () => getSalesLocations(page, pageSize, search),
  });

  return {
    data,
    status,
    isLoading,
    isError,
    error,
    isSuccess,
  };
};

export const useGetSalesLocation = (id) => {
  const { data, isLoading, status, isError, error, isSuccess } = useQuery({
    queryKey: ["sales-location", id],
    queryFn: () => getSalesLocation(id),
    enabled: !!id,
  });

  return {
    data,
    status,
    isLoading,
    isError,
    error,
    isSuccess,
  };
};


export const useUpdateSalesLocation = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { showNotification } = useNotification();
  
  return useMutation({
    mutationFn: ({ id, data }) => updateSalesLocation(id, data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["sales-locations"] });
      await queryClient.invalidateQueries({ queryKey: ["channel"] });
      
      // Show success notification
      showNotification('success', 'Channel updated successfully!');
      
    },
    onError: (error) => {
      console.error("Error updating channel:", error);
      
      // Show error notification
      let errorMessage = 'Error updating channel. Please try again.';
      if (error?.response?.data?.error?.message) {
        errorMessage = error.response.data.error.message;
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }
      
      showNotification('danger', errorMessage);
    },
  });
};

export const useDeleteSalesLocation = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();
  
  return useMutation({
    mutationFn: (id) => deleteSalesLocation(id),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["sales-locations"] });
      
      showNotification('success', 'Sales location deleted successfully!');
    },
    onError: (error) => {
      console.error("Error deleting sales location:", error);
      
      // Show error notification
      let errorMessage = 'Error deleting sales location. Please try again.';
      if (error?.response?.data?.error?.message) {
        errorMessage = error.response.data.error.message;
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }
      
      showNotification('danger', errorMessage);
    },
  });
};
